
export default function presentDownload(filename: string, data: Blob) {
  const a = document.createElement("a");
  a.download = filename;
  a.href = window.URL.createObjectURL(data);
  a.click();
}
